'use client'
import { compactClassName } from '@/components/homepage-october/compact'
import * as React from 'react'
import { gunzipSync, strFromU8 } from 'fflate'
import { TooltipProvider } from '@/components/ui/tooltip'
import { CompareTray, Departments, MobileBar, SiteHeader, SkipLink, TopBar } from './sections/Chrome'
import { Deals } from './sections/Deals'
import { Hero, Trust } from './sections/Hero'
import { SECTIONS, SECTIONS_FOOTER } from './sections'
import { ShopProvider, useShop } from './state'
import { watchImages } from './blocks/Img'
import { DestinationProvider } from './blocks/DestinationLink'
import type { Model } from './types'
import './homepage.css'

const Panels = React.lazy(() => import('./blocks/ShoppingPanels').then(module => ({ default: module.Panels })))

function ShoppingPanels({ model }: { model: Model }) {
  const shop = useShop()
  if (!shop.panel) return null
  return <React.Suspense fallback={<div role="status" className={compactClassName("fixed bottom-20 left-1/2 z-50 -translate-x-1/2 rounded-full border bg-white px-5 py-3 text-sm shadow-lg")}>Opening… <button type="button" onClick={shop.close} className={compactClassName("ml-3 text-[#0454c0] underline")}>Cancel</button></div>}><Panels model={model} /></React.Suspense>
}

export function OctoberHomepage({ model }: { model: Model }) {
  React.useEffect(() => watchImages(), [])
  return <div className={compactClassName("homepage-october")}><DestinationProvider gates={model.destinations}><ShopProvider><TooltipProvider delayDuration={200}>
    <SkipLink m={model.header.skip} /><TopBar m={model.util} />
    <SiteHeader m={model.header} model={model} /><Departments m={model.depts} />
    <main id="main-content" tabIndex={-1} className={compactClassName("pb-16 md:pb-0")}>
      <Hero m={model.hero} /><Trust m={model.trust} />
      <div data-deferred="Deals"><Deals m={model.deals} /></div>
      {SECTIONS.map(({ key, C }) => <div key={key} data-deferred={key}><C model={model} /></div>)}
    </main>
    <SECTIONS_FOOTER.C model={model} /><CompareTray /><MobileBar m={model.mbar} /><ShoppingPanels model={model} />
  </TooltipProvider></ShopProvider></DestinationProvider></div>
}

/** The server HTML remains complete; only the duplicate hydration data is compressed. */
export function OctoberHomepagePayload({ payload }: { payload: string }) {
  const model = React.useMemo(() => JSON.parse(strFromU8(gunzipSync(Uint8Array.from(atob(payload), c => c.charCodeAt(0))))) as Model, [payload])
  return <OctoberHomepage model={model} />
}
